import React from 'react'
import { useDispatch } from 'react-redux'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
    TableContainer,
    Paper,
    TextField,
    Box,
    Typography
} from '@mui/material'
import { useChangeValByRow, useChangeValByserviceID } from '../../hooks/dynamicform.hooks'
import { rerender } from '../../redux/DynamicForms/dynamicFormsActions'

const TableWithFilter = ({ tableData, onChange, state, setState, handleAddRowChanges, DialogData, openPopupSelect }) => {
    const changeValBySecRow = useChangeValByRow()
    const changeValByserviceID = useChangeValByserviceID()
    const dispatch = useDispatch()

    const proceedWithRowClick = (ROW, e) => {
        e.stopPropagation();
        if (DialogData && Object.keys(DialogData).length > 0) {
            handleAddRowChanges?.(ROW);
        } else {
            Object.keys(ROW)?.forEach((one) => {
                if (ROW[one] !== null) {
                    let willStore_val = ROW[one];
                    if (openPopupSelect !== undefined) {
                        changeValBySecRow(one, "serviceKey", "val", willStore_val, openPopupSelect);
                    } else {
                        changeValByserviceID(one, "serviceKey", "val", willStore_val);
                    }
                }
            });
        }

        setState();
        dispatch(rerender(false));
    };

    return (
        <Box sx={{ p: 1 }}>
            <Box sx={{ mb: 2 }}>
                <TextField
                    fullWidth
                    label="Search"
                    variant="outlined"
                    size="small"
                    value={tableData?.search || ""}
                    onChange={onChange}
                />
            </Box>
            <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400, overflow: 'auto', borderRadius: 1 }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            {tableData?.filteredData && tableData?.filteredData?.length > 0 && Object.keys(tableData?.filteredData[0])?.map((item, index) => (
                                <TableCell key={index} sx={{ fontWeight: 600, bgcolor: 'action.hover' }}>{item}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData?.filteredData?.map((item, index) => (
                            <TableRow
                                key={index}
                                hover
                                onClick={(e) => proceedWithRowClick(item, e)}
                                sx={{ cursor: 'pointer' }}
                            >
                                {Object.keys(item)?.map((key, idx) => (
                                    <TableCell key={idx} sx={{ fontSize: '0.8125rem' }}>{item[key]}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default TableWithFilter
